/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {SearchCriteriaConfiguration} from '../configuration/search-criteria-configuration';
import {DropdownCriterionSelectionModel} from '../dropdown-criteria-selection/models/dropdown-criterion-selection.model';
import {DropdownCriteriaSelectionModel} from '../dropdown-criteria-selection/models/dropdown-criteria-selection.model';

export class GlobalSearchCriteriaConfigurationMapper {

    static fromSearchCriteriaConfigurationToDropdownModelHashmap(
            searchCriteriaConfiguration: readonly SearchCriteriaConfiguration[]
    ): DropdownCriteriaSelectionModel {
        const dropdownDataByContextCriterionCode: DropdownCriteriaSelectionModel = {
            criteria: new Map<string, DropdownCriterionSelectionModel>()
        };

        searchCriteriaConfiguration.forEach((contextCriterion) => {
            dropdownDataByContextCriterionCode.criteria.set(contextCriterion.code, {
                name: contextCriterion.name,
                color: contextCriterion?.color,
                disabled: false,
                subDropdown: GlobalSearchCriteriaConfigurationMapper
                        .fromCriterionConfigurationToSubDropdownModelHashmap(contextCriterion.criteria),
                inputTypeSearch: contextCriterion?.inputTypeSearch,
                dynamicDropdownContext: contextCriterion?.dynamicCriteria
            });
        });

        return dropdownDataByContextCriterionCode;
    }

    static fromCriterionConfigurationToSubDropdownModelHashmap(
            criterionConfiguration: readonly SearchCriteriaConfiguration[]
    ): Map<string, DropdownCriterionSelectionModel> {
        const subDropdownDataByCriterionCode = new Map<string, DropdownCriterionSelectionModel>();

        criterionConfiguration.forEach((criterion) => {
            subDropdownDataByCriterionCode.set(criterion.code, {
                name: criterion.name,
                color: criterion?.color,
                disabled: false,
                inputTypeSearch: criterion?.inputTypeSearch,
                dynamicDropdownContext: criterion?.dynamicCriteria
            });
        });

        return subDropdownDataByCriterionCode;
    }
}
